import AppointmentStatusSearchCard from './AppointmentStatusSearchCard';

export default AppointmentStatusSearchCard;
